import "./tab2.scss"
import Button from "../../../../../../../../../core/button/button";
import BuyAbleSocialMediaCard, {
    IBuyAbleSocialMediaCard
} from "../../../../../../../../../ui/socialmediacard/buyable/buyablesocialmediacard";
import * as React from "react";
import {useState} from "react";

const Tab2 = () => {
    const [activateSocialMediaCard1, setActivateSocialMediaCard1] = useState("none");
    const [activateSocialMediaCard2, setActivateSocialMediaCard2] = useState("none");
    const [activateSocialMediaCard3, setActivateSocialMediaCard3] = useState("none");
    const [activateSocialMediaCard4, setActivateSocialMediaCard4] = useState("none");
    const [activateSocialMediaCard5, setActivateSocialMediaCard5] = useState("none");
    const [activateSocialMediaCard6, setActivateSocialMediaCard6] = useState("none");
    const socialMediaItems: IBuyAbleSocialMediaCard[] = [
        {
            image: require("../../../../../../../../../assets/images/avatars/Avatar8.png"),
            name: "صدف بیوتی",
            id: "@sadafbeauty",
            verified: true,
            follower: "فالور : ۳ میلیون",
            options: ["سه پست در روز ۲۵۰ هزارتومان", "چهار استوری در هفته", "سه پست در روز ۲۵۰ هزارتومان", "استوری صحبت کردن خودم"],
            price: "750 هزار",
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard1,
            setActivateSocialMedia: setActivateSocialMediaCard1
        },
        {
            image: require("../../../../../../../../../assets/images/avatars/Avatar9.png"),
            name: "امل",
            id: "@emelbeauty",
            follower: "فالور : ۵ میلیون",
            options: ["سه پست در روز ۲۵۰ هزارتومان", "چهار استوری در هفته", "سه پست در روز ۲۵۰ هزارتومان", "استوری صحبت کردن خودم"],
            price: "750 هزار",
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard2,
            setActivateSocialMedia: setActivateSocialMediaCard2
        },
        {
            image: require("../../../../../../../../../assets/images/avatars/Avatar10.png"),
            name: "الناز گلرخ",
            id: "@elnazgolrokh",
            follower: "فالور : ۵ میلیون",
            options: ["سه پست در روز ۲۵۰ هزارتومان", "چهار استوری در هفته", "سه پست در روز ۲۵۰ هزارتومان", "استوری صحبت کردن خودم"],
            price: "750 هزار",
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard3,
            setActivateSocialMedia: setActivateSocialMediaCard3
        },
        {
            image: require("../../../../../../../../../assets/images/avatars/Avatar11.png"),
            name: "امل",
            id: "@emelbeauty",
            follower: "فالور : ۲ میلیون",
            options: ["سه پست در روز ۲۵۰ هزارتومان", "چهار استوری در هفته", "سه پست در روز ۲۵۰ هزارتومان", "استوری صحبت کردن خودم"],
            price: "750 هزار",
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard4,
            setActivateSocialMedia: setActivateSocialMediaCard4
        }, {
            image: require("../../../../../../../../../assets/images/avatars/Avatar12.png"),
            name: "صدف بیوتی",
            id: "@sadafbeauty",
            verified: true,
            follower: "فالور : ۲ میلیون",
            options: ["سه پست در روز ۲۵۰ هزارتومان", "چهار استوری در هفته", "سه پست در روز ۲۵۰ هزارتومان", "استوری صحبت کردن خودم"],
            price: "750 هزار",
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard5,
            setActivateSocialMedia: setActivateSocialMediaCard5
        }, {
            image: require("../../../../../../../../../assets/images/avatars/Avatar13.png"),
            name: "الناز گلرخ",
            id: "@elnazgolrokh",
            follower: "فالور : ۲ میلیون",
            options: ["سه پست در روز ۲۵۰ هزارتومان", "چهار استوری در هفته", "سه پست در روز ۲۵۰ هزارتومان", "استوری صحبت کردن خودم"],
            price: "750 هزار",
            cardID: 0,
            activateSocialMedia: activateSocialMediaCard6,
            setActivateSocialMedia: setActivateSocialMediaCard6
        },
    ]
    return (
        <div className="Tab2">
            <div className="Filter-Header">
                <div className="row">
                    <div className="col-lg-7 col-12 mb-3">
                        <div className="Content-Search-Box">
                            <input type="search" name="contentSearch" id="contentSearch"
                                   className="Content-Search-Input"
                                   placeholder="جستجو در مبان نام و آدرس وبسایت ها ..."/>
                            <img
                                src={require("../../../../../../../../../assets/images/icons/SearchNormal.svg").default}
                                alt=""
                                className="img-fluid Content-Search-Image"/>
                        </div>
                    </div>
                    <div className="col-lg-5 col-12 mb-3">
                        <div className="Content-Filter-Box">
                            <Button type={"filter"} action={() => {
                            }} responsive={true}>
                                مرتب سازی
                                <img src={require("../../../../../../../../../assets/images/icons/Sort.svg").default}
                                     alt="" className="img-fluid pe-2"/>
                            </Button>
                            <Button type={"filter"} action={() => {
                            }} responsive={true}>
                                فیلتر کردن
                                <img src={require("../../../../../../../../../assets/images/icons/Filter.svg").default}
                                     alt="" className="img-fluid pe-2"/>
                            </Button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                {
                    socialMediaItems.map((socialMediaItem, index) => {
                        return (
                            <div key={index} className="col-xxl-3 col-xl-4 col-lg-6 col-md-6 col-12 mb-3">
                                <BuyAbleSocialMediaCard image={socialMediaItem.image} name={socialMediaItem.name}
                                                        id={socialMediaItem.id} verified={socialMediaItem.verified}
                                                        follower={socialMediaItem.follower}
                                                        options={socialMediaItem.options} price={socialMediaItem.price}
                                                        cardID={index}
                                                        activateSocialMedia={socialMediaItem.activateSocialMedia}
                                                        setActivateSocialMedia={socialMediaItem.setActivateSocialMedia}/>
                            </div>
                        );
                    })
                }
            </div>
            <div className="Result-Box d-flex justify-content-around align-items-center flex-wrap">
                <div>
                    <img src={require("../../../../../../../../../assets/images/icons/Result.svg").default} alt=""
                         className="img-fluid ps-2"/>
                    <span className="Result-Box-Title">مجموع : </span>
                    <span className="Result-Box-Result">150,000 میلیون</span>
                </div>
                <div>
                    <img src={require("../../../../../../../../../assets/images/icons/View.svg").default} alt=""
                         className="img-fluid ps-2"/>
                    <span className="Result-Box-Title">تخمین بازدید : </span>
                    <span className="Result-Box-Result">14,000 تا 25,000</span>
                </div>
                <div>
                    <img src={require("../../../../../../../../../assets/images/icons/Budget.svg").default} alt=""
                         className="img-fluid ps-2"/>
                    <span className="Result-Box-Title">بودجه اولیه شما : </span>
                    <span className="Result-Box-Result">120,000 میلیون</span>
                </div>
            </div>
        </div>
    );
}

export default Tab2